export default function validatePassword(password) {
    if (!password) {
      return "Campo Obrigatório"
    }

    if (password.length < 6) {
      return "Utilize ao menos 6 caracteres"
    }
  }